import React from 'react'
import {Container1Search} from './Container1Search'
import {Container2Div} from './Container2Div'
import {Container3Grid} from './Container3Grid'
export const UpperPart = () => {
  return (
    <div>
        <Container1Search/>
        <Container2Div/>
        <Container3Grid/>
    </div>
  )
}
